var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "filter-container-content",
          staticStyle: { "margin-top": "0" },
        },
        [
          _c(
            "div",
            { staticClass: "filter-container-new" },
            [
              _c(
                "el-form",
                {
                  ref: "filterForm",
                  attrs: {
                    rules: _vm.rules,
                    "label-position": "top",
                    model: _vm.filterForm,
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 14 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired is-required",
                              attrs: {
                                label: _vm.$t("blExchangeAppointment.pod"),
                                prop: "portCode",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("home.select"),
                                  },
                                  model: {
                                    value: _vm.filterForm.portCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterForm, "portCode", $$v)
                                    },
                                    expression: "filterForm.portCode",
                                  },
                                },
                                _vm._l(_vm.portCodes, function (item) {
                                  return _c("el-option", {
                                    key: item,
                                    attrs: {
                                      label: item,
                                      value: item,
                                      "data-item": item,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "reqired",
                              attrs: {
                                label:
                                  _vm.filterForm.portCode === "CNXMN"
                                    ? _vm.$t(
                                        "blExchangeAppointment.blNoAndCode"
                                      )
                                    : _vm.filterForm.portCode &&
                                      _vm.filterForm.portCode.startsWith("PH")
                                    ? _vm.$t(
                                        "blExchangeAppointment.blNoAndCode4PH"
                                      )
                                    : _vm.$t(
                                        "blExchangeAppointment.blNoAndContainerNo"
                                      ),
                                prop: "blNo",
                              },
                            },
                            [
                              _c("ClearableTextInput", {
                                attrs: {
                                  autosize: { minRows: 2, maxRows: 6 },
                                  values: _vm.filterForm.blNo,
                                },
                                model: {
                                  value: _vm.filterForm.blNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "blNo", $$v)
                                  },
                                  expression: "filterForm.blNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "28px" },
                          attrs: { span: 3 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-primary",
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.search")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-plain-primary",
                              on: { click: _vm.resetFn },
                            },
                            [_vm._v(_vm._s(_vm.$t("btn.reset")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "28px" },
                          attrs: { span: 5 },
                        },
                        [
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "red",
                              },
                              attrs: {
                                icon: "el-icon-warning-outline",
                                disabled: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.filterForm.portCode === "CNXMN"
                                      ? _vm.$t(
                                          "blExchangeAppointment.blNoCNXMNTips"
                                        )
                                      : _vm.filterForm.portCode &&
                                        _vm.filterForm.portCode.startsWith("PH")
                                      ? _vm.$t(
                                          "blExchangeAppointment.blNoPHTips"
                                        )
                                      : _vm.$t("blExchangeAppointment.blNoTips")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c("p", { staticClass: "container-content-tips" }, [
          _vm._v(_vm._s(_vm.$t("blExchangeAppointment.ApplicablePorts"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container-new" },
          [
            _c(
              "div",
              {
                staticClass: "item-title",
                staticStyle: { "margin-top": "10px" },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("blExchangeAppointment.foreSpeakInfo"))),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-primary",
                    attrs: { icon: "el-icon-time", type: "primary" },
                    on: { click: _vm.handleBatchReservation },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("btn.foreSpeak")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "hot-table",
              {
                ref: "hotTable",
                attrs: {
                  "data-source": _vm.tableData,
                  settings: _vm.hotSettings,
                  "current-page": _vm.listQuery.currentPage,
                  "page-size": _vm.listQuery.pageSize,
                  "selection-column-title": _vm.$t("blExchangeAppointment.No"),
                  "has-tip": "",
                  "empty-text": _vm.$t("table.emptyText"),
                },
                on: { rowClick: _vm.handleDouble },
              },
              [
                _c("hot-column", {
                  attrs: {
                    data: "outVesselCode",
                    title: _vm.$t("blExchangeAppointment.outVesselCode"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "outVoyageNo",
                    title: _vm.$t("blExchangeAppointment.outVoyageNo"),
                    width: 100,
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "outVoyageLeg",
                    title: _vm.$t("blExchangeAppointment.outVoyageLeg"),
                    width: 100,
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "inVesselCode",
                    title: _vm.$t("blExchangeAppointment.inVesselCode"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "inVoyageNo",
                    title: _vm.$t("blExchangeAppointment.inVoyageNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "inVoyageLeg",
                    title: _vm.$t("blExchangeAppointment.inVoyageLeg"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "del",
                    title: _vm.$t("blExchangeAppointment.pod"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "blNo",
                    title: _vm.$t("blExchangeAppointment.blNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "deliverableDate",
                    title: _vm.$t("blExchangeAppointment.deliverableDate"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "eta",
                    title: _vm.$t("blExchangeAppointment.eta"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "edoSentStatus",
                    renderer: _vm.columnRenderer,
                    title: _vm.$t("blExchangeAppointment.edoSentStatus"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "forespeakStatus",
                    renderer: _vm.forespeakStatusRenderer,
                    title: _vm.$t("blExchangeAppointment.forespeakStatus"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "releaseStatus",
                      "filter-list": _vm.releaseStatusList,
                      title: _vm.$t("blExchangeAppointment.releaseStatus"),
                      "class-name": "htCenter",
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    title: _vm.$t(
                      "appointmentHistoryTable.downloadFile4Invoice"
                    ),
                    "class-name": "htCenter",
                    renderer: _vm.columnRendererDownload4Invoice,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "pagePanel",
              staticStyle: { "text-align": "left" },
              attrs: {
                total: _vm.total,
                page: _vm.listQuery.currentPage,
                limit: _vm.listQuery.pageSize,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "currentPage", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "pageSize", $event)
                },
                pagination: _vm.searchFn,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container-new" },
          [
            _c(
              "div",
              {
                staticClass: "item-title",
                staticStyle: { "margin-top": "10px" },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("blExchangeAppointment.foreSpeakCost"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "hot-table",
              {
                ref: "hotTableCost",
                attrs: {
                  "data-source": _vm.tableCostData,
                  settings: _vm.hotCostSettings,
                  "current-page": _vm.listQuery.currentPage,
                  "page-size": _vm.listQuery.pageSize,
                  "has-tip": "",
                  "selection-column-title": _vm.$t("blExchangeAppointment.No"),
                  "empty-text": _vm.$t("table.emptyText"),
                },
              },
              [
                _c("hot-column", {
                  attrs: {
                    data: "blNo",
                    title: _vm.$t("blExchangeAppointment.blNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "soaNo",
                    title: _vm.$t("blExchangeAppointment.soaNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "chargeCode",
                    title: _vm.$t("blExchangeAppointment.chargeCode"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "currency",
                    title: _vm.$t("blExchangeAppointment.currency"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "amount",
                    title: _vm.$t("blExchangeAppointment.amount"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "containerType",
                    title: _vm.$t("blExchangeAppointment.containerType"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "cargoType",
                    title: _vm.$t("blExchangeAppointment.cargoType"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "invoiceNo",
                    title: _vm.$t("blExchangeAppointment.invoiceNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "exchangeRate",
                    title: _vm.$t("blExchangeAppointment.exchangeRate"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "invoiceAmount",
                    title: _vm.$t("blExchangeAppointment.invoiceAmount"),
                    "class-name": "htCenter",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-summary-container" },
              [
                _vm.filterForm.portCode &&
                _vm.filterForm.portCode.startsWith("PH")
                  ? _c("div", { staticClass: "summary-totals" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("blExchangeAppointment.totalAmount")) +
                            ": " +
                            _vm._s(_vm.formattedCurrencySums)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("blExchangeAppointment.totalInvoiceAmount")
                          ) +
                            ": " +
                            _vm._s(_vm.totalInvoiceAmountSum.toFixed(2))
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "pagePanel",
                  staticStyle: { "text-align": "left" },
                  attrs: {
                    total: _vm.totalCost,
                    page: _vm.listQueryTwo.currentPage,
                    limit: _vm.listQueryTwo.pageSize,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQueryTwo, "currentPage", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQueryTwo, "pageSize", $event)
                    },
                    pagination: _vm.searchFnCost,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("batchReservationNb", {
        ref: "batchReservationNb",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationNbVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "payment-status": _vm.paymentStatus,
          "forespeak-status": _vm.forespeakStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "payment-status-list": _vm.paymentStatusList,
          "forespeak-status-list": _vm.forespeakStatusList,
          "edo-payment-method": _vm.edoPaymentMethod,
          "edo-credit-id": _vm.edoCreditId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationNbVisible = $event
          },
          handleCloseReservationNb: _vm.handleCloseReservationNb,
        },
      }),
      _vm._v(" "),
      _c("batchReservationComm", {
        ref: "batchReservationComm",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationCommonVisible,
          vvLBlNo: _vm.vvLBlNo,
          paymentStatus: _vm.paymentStatus,
          forespeakStatus: _vm.forespeakStatus,
          forespeakBlNo: _vm.forespeakBlNo,
          paymentStatusList: _vm.paymentStatusList,
          forespeakStatusList: _vm.forespeakStatusList,
          edoPaymentMethod: _vm.edoPaymentMethod,
          edoCreditId: _vm.edoCreditId,
          portCode: _vm.filterForm.portCode,
        },
        on: {
          handleCloseReservationCommon: _vm.handleCloseReservationCommon,
          "update:visible": function ($event) {
            _vm.batchReservationCommonVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("batchReservationQd", {
        ref: "batchReservationQd",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationQdVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "payment-status": _vm.paymentStatus,
          "forespeak-status": _vm.forespeakStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "payment-status-list": _vm.paymentStatusList,
          "forespeak-status-list": _vm.forespeakStatusList,
          "edo-payment-method": _vm.edoPaymentMethod,
          "edo-credit-id": _vm.edoCreditId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationQdVisible = $event
          },
          handleCloseReservationQd: _vm.handleCloseReservationQd,
        },
      }),
      _vm._v(" "),
      _c("batchReservationSk", {
        ref: "batchReservationSk",
        attrs: {
          "destroy-on-close": true,
          width: "50%",
          visible: _vm.batchReservationSkVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "payment-status": _vm.paymentStatus,
          "forespeak-status": _vm.forespeakStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "payment-status-list": _vm.paymentStatusList,
          "forespeak-status-list": _vm.forespeakStatusList,
          "edo-credit-id": _vm.edoCreditId,
          del: _vm.filterForm.portCode,
          vvls: _vm.vvls,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationSkVisible = $event
          },
          handleCloseReservationSk: _vm.handleCloseReservationSk,
        },
      }),
      _vm._v(" "),
      _c("batchReservationXg", {
        ref: "batchReservationXg",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationXgVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "payment-status": _vm.paymentStatus,
          "forespeak-status": _vm.forespeakStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "payment-status-list": _vm.paymentStatusList,
          "forespeak-status-list": _vm.forespeakStatusList,
          "edo-payment-method": _vm.edoPaymentMethod,
          "edo-credit-id": _vm.edoCreditId,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationXgVisible = $event
          },
          handleCloseReservationXg: _vm.handleCloseReservationXg,
        },
      }),
      _vm._v(" "),
      _c("batchReservationXm", {
        ref: "batchReservationXm",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationXmVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "payment-status": _vm.paymentStatus,
          "forespeak-status": _vm.forespeakStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "payment-status-list": _vm.paymentStatusList,
          "forespeak-status-list": _vm.forespeakStatusList,
          "edo-credit-id": _vm.edoCreditId,
          del: _vm.del,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationXmVisible = $event
          },
          handleCloseReservationXm: _vm.handleCloseReservationXm,
        },
      }),
      _vm._v(" "),
      _c("searchContainerPh2", {
        ref: "searchContainer",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.searchContainerDialogVisible,
          "bl-no": _vm.forespeakBlNo,
        },
        on: {
          "update:visible": function ($event) {
            _vm.searchContainerDialogVisible = $event
          },
          handleNextConfirmPrint: _vm.handleNextConfirmPrint,
        },
      }),
      _vm._v(" "),
      _vm.confirmPrintingDialogVisible
        ? _c("confirmPrintingDialogPh", {
            ref: "confirmPrintingDialog",
            attrs: {
              "destroy-on-close": true,
              width: "70%",
              visible: _vm.confirmPrintingDialogVisible,
              "form-dialog": _vm.printDialog,
              params: this.params,
            },
            on: {
              "update:visible": function ($event) {
                _vm.confirmPrintingDialogVisible = $event
              },
              handlePreviousStep: _vm.handlePreviousStep,
              handleNextStep: _vm.handleNextStep,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("batchReservationPhSaveDialog", {
        ref: "batchReservationPhSaveDialog",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.batchReservationPhVisible,
          "vv-l-bl-no": _vm.vvLBlNo,
          "forespeak-status": _vm.forespeakStatus,
          "payment-status-list": _vm.paymentStatusPHList,
          "payment-status": _vm.paymentStatus,
          "forespeak-bl-no": _vm.forespeakBlNo,
          "ecm-ngb-edo-owner-type": _vm.ecmNgbEdoOwnerType,
          "forespeak-status-list": _vm.forespeakStatusList,
          "ph-edo-bank-list": _vm.phBankList,
          del: _vm.del,
          "edo-credit-id": _vm.edoCreditId,
          "has-demurrage": _vm.hasDemurrage,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchReservationPhVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }